import React, { useCallback, useMemo, useState } from 'react';
import { Button, Popover } from 'antd';
import { DownOutlined, GlobalOutlined } from '@ant-design/icons';
import i18n, { resolveSupportedLanguage } from '../i18n';
import './LanguageSwitcher.css';

const LANGUAGE_OPTIONS = [
  ['en', 'English'],
  ['zh', '简体中文'],
  ['zh-TW', '繁體中文'],
  ['ja', '日本語'],
  ['de', 'Deutsch'],
  ['es', 'Español'],
  ['fr', 'Français'],
  ['pt', 'Português'],
  ['ar', 'العربية'],
  ['ko', '한국어'],
];

const LanguageSwitcher = ({ onLanguageChange, style, ...selectProps }) => {
  const [open, setOpen] = useState(false);
  const currentLanguage = resolveSupportedLanguage(i18n.resolvedLanguage || i18n.language);

  const options = useMemo(
    () => LANGUAGE_OPTIONS.map(([value, label]) => ({ value, label })),
    []
  );
  const currentOption = options.find((option) => option.value === currentLanguage) || options[0];

  const handleChange = useCallback(async (value) => {
    await i18n.changeLanguage(value);
    try {
      localStorage.setItem('i18nextLng', value);
      localStorage.setItem('language', value);
    } catch (error) {
      // Ignore storage failures so language switching does not break the page.
    }
    if (typeof onLanguageChange === 'function') {
      onLanguageChange(value);
    }
    setOpen(false);
  }, [onLanguageChange]);

  const content = (
    <div className="language-switcher__menu">
      {options.map((option) => {
        const selected = option.value === currentLanguage;
        return (
          <button
            key={option.value}
            type="button"
            className={`language-switcher__item${selected ? ' language-switcher__item--selected' : ''}`}
            onClick={() => handleChange(option.value)}
          >
            <span className="language-switcher__bullet" aria-hidden="true">{selected ? '•' : '○'}</span>
            <span className="language-switcher__label">{option.label}</span>
          </button>
        );
      })}
    </div>
  );

  return (
    <Popover
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      content={content}
      overlayClassName="language-switcher__popover"
      {...selectProps}
    >
      <Button
        type="text"
        className="language-switcher__trigger"
        style={style}
        icon={<GlobalOutlined />}
      >
        <span className="language-switcher__trigger-label">{currentOption.label}</span>
        <DownOutlined className="language-switcher__trigger-arrow" />
      </Button>
    </Popover>
  );
};

export default LanguageSwitcher;
